import React, { ForwardedRef, forwardRef } from 'react';
import { motion } from 'framer-motion';

export interface SkeletonProps {
	height: string;
	width: string;
	style?: React.CSSProperties;
}

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(function Skeleton({ style, ...props }: SkeletonProps, ref: ForwardedRef<HTMLDivElement>) {
	return (
		<motion.div
			ref={ref}
			className="relative overflow-hidden rounded-2xl bg-skeleton bg-[length:200%_100%] animate-shine"
			style={{ ...style, ...props }}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
		</motion.div>
	);
});
